import { LuCircleDot } from "react-icons/lu"
import { useDispatch, useSelector } from 'react-redux'
import { Link, useNavigate, useLocation } from 'react-router-dom'
import { sidebarTodo } from '../../redux/slices/assets'
import { SessionManager } from '../../utils'
import { useTranslation } from 'react-i18next'

export const SidebarImport = {
    LuCircleDot,
    useDispatch,
    useSelector,
    Link,
    useNavigate,
    useLocation,
    sidebarTodo,
    SessionManager,
    useTranslation
}